import { ref } from "vue";
import axios from "axios";
import { useToast } from "vue-toastification";
import  useErrors from "./ErrorsServices";
export default function usePermissions() {
    const permissions = ref([]);
    const permissionsByRole = ref([]);
    const permissionsByUser = ref([]);
    const toast = useToast();

    const getPermissions = async () => {
        let response = await axios.get("/api/permissions");
        permissions.value = response.data;
        return response
    };

    const fetchPermissionsByRole = async (roleId) => {
        let response = await axios.get(`/api/get_permissions_by_role/${roleId}`);
        permissionsByRole.value = response.data;
    }

    const fetchPermissionsByUser = async (userId) => {
        let response = await axios.get(
            `/api/get_permissions_by_user/${userId}`
        );
        permissionsByUser.value = response.data;
    };

    const assignPermission = async(permission, type) => {
        await axios.put(`/api/assign_permission/${type}`, permission)
    }

    const createPermission = async (permission) => {
        try {
            await axios.post("/api/permissions", permission);
            toast.success("La permission a été créée avec succès");
        } catch (error) {
            useErrors(error, "la permission");
        }



    };

    const updatePermission = async (permission) => {
        await axios
            .patch(`/api/permissions/${permission.id}`, permission)
    };

    const destroyPermission = async (permissionId) => {
        await axios
            .delete(`/api/permissions/${permissionId}`)
    };

    return {
        permissions,
        permissionsByRole,
        permissionsByUser,
        createPermission,
        updatePermission,
        destroyPermission,
        assignPermission,
        getPermissions,
        fetchPermissionsByRole,
        fetchPermissionsByUser,
    };
}
